"use strict";
/**
 * User-facing explanations for the sourcing basis of a verdict, shared so the
 * web, mobile and extension surfaces describe `confidenceBasis` identically.
 *
 * The wording tracks the engine: a live web search runs only when retrieval is
 * degraded, fewer than two sources survive, or every survivor is the same type
 * (VerificationService.webSearchTriggerReason); the AI-knowledge basis is taken
 * whenever fewer than two sources exist (ConfidenceCalculator).
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SOURCING_EXPLAINER = exports.SOURCING_LABEL = void 0;
exports.SOURCING_LABEL = {
    web_search: 'Based on a live web search',
    ai_knowledge: 'Based on AI knowledge — limited external sources',
};
exports.SOURCING_EXPLAINER = {
    web_search: 'Treu searched the open web while checking this claim, because its trusted source network came back thin — fewer than two usable sources, sources that were all of the same kind, or providers that failed to respond. This does not happen on every verification: most answers come from Treu’s standing sources (research, medical, government, fact-check and news databases), and this tag only appears when a live search shaped the result.',
    ai_knowledge: 'Fewer than two usable external sources came back for this claim, so the score rests on the AI model’s own knowledge instead of the source-based formula. Any source listed below is worth reading, but treat this as a starting point rather than a corroborated verdict — the model’s knowledge has a cutoff date and no citation behind it.',
};
//# sourceMappingURL=sourcing-copy.js.map